import { ElMessage } from 'element-plus';

export function useMessageError() {
  const open = (err) => {
    ElMessage.error({
      message: err && err.message ? err.message : err ? err : 'Hubo un error',
      showClose: true,
      duration: 6000,
    });
  };
  return { open };
}
